import he from "he";

export const isValidUrl = (url) => {

    const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
    return urlRegex.test(url);
};

export const isPdfFile = (fileName) => {
    const pdfRegex = /\.pdf$/i;
    return pdfRegex.test(fileName);
};


export const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const convertIntoMath = (str) => {
    if (!str) {
        return str;
    }
    return str
        ?.replace('<span class="math-tex">\\(', '$')
        ?.replace('\\)</span>', '$');
};

export const noColumnInQuestion = ['8', '9', '10', '11', '12'];
export const XPattern = /\(x\d+\)\./g;

export const madeFinalObject = (payload, isFromEdit) => {
    let questionCount = 0;

    let finalPayload = payload?.map((item, index) => {
        return {
            ...item,
            divisions: item?.divisions?.map((data) => {
                let questionDataPayload = [];

                data?.question_data?.forEach((item, index) => {
                    item = {
                        ...item,
                        question: item?.finalquestion || item?.question,
                        answer: item?.finalAnswer || item?.answer,
                    };


                    const subID = Math.floor(Math.random() * 1000);
                    if (item?.finalquestion?.includes('(x1).')) {
                        const paragraphsArr = item?.finalquestion
                            ?.split(XPattern)
                            .map((item) => {
                                return item.trim();
                            });

                        const paragraph = paragraphsArr.shift();

                        paragraphsArr?.forEach((ele, index) => {
                            const answers = item?.finalAnswer?.split(XPattern);

                            questionCount++;
                            questionDataPayload.push({
                                ...item,
                                ...(index == 0 && {
                                    paragraph: paragraph.replace(/<[^>]+>/g, '').trim(),
                                }),
                                question_id: isFromEdit ? item?.question_id : questionCount,
                                question: convertIntoMath(ele.replace(/<[^>]+>/g, '').trim()),
                                finalquestion: convertIntoMath(ele.replace(/<[^>]+>/g, '').trim()),
                                qType: item.qtype,
                                subID: subID,
                                answer: convertIntoMath(answers[index + 1]),
                                finalAnswer: convertIntoMath(answers[index + 1]),
                                html_tag: item.html_tag || item?.html_question,
                                m_equation: item.m_equation,
                                id: item.id,
                            });
                        });
                    } else if (
                        item?.perfact_metch.length > 0 &&
                        !noColumnInQuestion.includes(item?.qtype)
                    ) {
                        item?.perfact_metch?.forEach((ele, ind) => {
                            questionCount++;
                            questionDataPayload.push({
                                ...item,
                                ...(ind == 0 && {
                                    paragraph: convertIntoMath(item?.finalquestion?.trim()),
                                }),
                                question_id: isFromEdit ? item?.question_id : questionCount,
                                questionLeft: convertIntoMath(ele?.finalquestion),
                                questionRight: convertIntoMath(ele?.finalanswer),
                                rightAnswer: convertIntoMath(ele?.finalrightAnswer),
                                id: item.id,
                                answer: convertIntoMath(item.answer),
                                qType: item.qtype,
                                que_id: item?.que_id,
                                html_tag: item.html_tag || item?.html_question,
                                m_equation: item.m_equation,
                                perfact_metch: [],
                            });
                        });
                    } else {
                        questionCount++;
                        questionDataPayload.push({
                            ...item,
                            question_id: isFromEdit ? item?.question_id : questionCount,
                            html_tag: item.html_tag || item?.html_question,
                            m_equation: item.m_equation,
                            question: convertIntoMath(item.finalquestion),
                            id: item.id,
                            qType: item.qtype,
                            answer: convertIntoMath(item.finalAnswer),

                            ...(item?.option1 &&
                                item?.option2 &&
                                item?.option3 &&
                                item?.option4 && {
                                answers: [
                                    {
                                        answer: convertIntoMath(item?.option1),
                                    },
                                    {
                                        answer: convertIntoMath(item?.option2),
                                    },
                                    {
                                        answer: convertIntoMath(item?.option3),
                                    },
                                    {
                                        answer: convertIntoMath(item?.option4),
                                    },
                                ],
                            }),
                            ...(item?.option1 &&
                                item?.option2 &&
                                item?.option3 &&
                                item?.option4 && {
                                finalAnswers: [
                                    {
                                        answer: convertIntoMath(item?.finaloption1),
                                    },
                                    {
                                        answer: convertIntoMath(item?.finaloption2),
                                    },
                                    {
                                        answer: convertIntoMath(item?.finaloption3),
                                    },
                                    {
                                        answer: convertIntoMath(item?.finaloption4),
                                    },
                                ],
                            }),
                            ...(item?.option1_img &&
                                item?.option2_img &&
                                item?.option3_img &&
                                item?.option4_img && {
                                imgAnswers: [
                                    {
                                        answer: convertIntoMath(item?.option1_img),
                                    },
                                    {
                                        answer: convertIntoMath(item?.option2_img),
                                    },
                                    {
                                        answer: convertIntoMath(item?.option3_img),
                                    },
                                    {
                                        answer: convertIntoMath(item?.option4_img),
                                    },
                                ],
                            }),
                        });
                    }
                });

                return {
                    ...data,
                    question_data: questionDataPayload,
                };
            }),
        };
    });

    return finalPayload;
};


export const dynamicSequence = (sections_info, isFromEdit) => {
    let orIndex = 0;
    let question_id_sequence = 0;
    let andId = 0;
    let data = sections_info?.map((section, i) => {
        return {
            ...section,
            divisions: section?.divisions?.map((div, j) => {
                return {
                    ...div,
                    question_data: div.question_data?.map((question, k) => {
                        question_id_sequence++;
                        if (
                            question.isOr ||
                            (question.questionRight && !question.questionLeft) ||
                            (question.isAnd && div.question_data[k - 1]?.isAnd)
                        ) {
                            orIndex += 1;
                        }
                        if (question.isAnd) {
                            andId += 1
                        } else {
                            andId = 0
                        }
                        const question_id = isFromEdit
                            ? question?.question_id
                            : (Number(question_id_sequence) - orIndex).toString();
                        return {
                            ...question,
                            question_id:
                                question.questionRight && !question.questionLeft
                                    ? ''
                                    : question_id,
                            andId: andId
                        };
                    }),
                };
            }),
        };
    });

    return data;
};

const regex = /<u>(.*?)<\/u>/;
export const hasImage = (text) => {
    if (
        text?.includes("pg/ckeditor") ||
        text?.includes("data:image") ||
        text?.includes("s3.ap-south-1.amazonaws.com") ||
        text?.includes("<br />") ||
        text?.includes("cellpadding") ||
        text?.includes("<math xmlns=") ||
        regex.test(text)
    ) {
        return true;
    } else {
        return false;
    }
};

export const isTrueFalse = (item) => {
    if (item?.qtype == "3") {
        if (item?.answer == "1") {
            return "True";
        } else if (item?.answer == "0") {
            return "False";
        } else {
            return item?.finalAnswer;
        }
        // return true;
    } else {
        return item?.rightAnswer
            ? item?.rightAnswer
            : item?.finalAnswer
                ? item?.finalAnswer
                : item?.answer;
    }
};

export const removeFirstAndLastThreeChars = (sentence) => {
    try {
        const newSentence = he?.decode(
            sentence?.replace(/<\/?p>/g, "")?.replace(/<\/?br>/g, "")
        );
        if (sentence?.substring(0, 3) === "<p>" && sentence?.slice(-4) === "</p>") {
            return sentence?.substring(3, sentence?.length - 4);
        } else {
            return newSentence;
        }

    } catch (error) {

        return sentence
    }
};

export function replaceMathTagWithAltText(html) {
    // const regex = /<math xmlns=.*?alttext="([^"]+)".*?<\/math>/g;

    // return html.replace(regex, '$1');
    const regex = /<math.*?>(.*?)<\/math>/g;

    // const regex = /<math.*?<\/math>/g;

    if (html?.includes("<math xmlns=")) {
        return html?.replace(/<\/?[^>]+>/g, "")?.trim();
    } else {
        return html;
    }
    // return html.replace(/<[^>]+>/g, '');
    // const mathtext = html.replace(regex, "")

    // return mathtext.replace(regex, '');
}